export default {
    data() {
        return {
            headerFixed: false,
            offsetTop: 0,
            offsetHeight: 0,
            header: '',
            scrollLeft:0
        }
    },
    mounted() {
        // handleScroll为页面滚动的监听回调
        // let fixedTable = document.getElementById('fixed-table');
        this.header = document.getElementById("fixedHeaderRoot");
        // 这里要得到top的距离和元素自身的高度
        this.offsetTop = this.header.offsetTop;
        this.offsetHeight = this.header.offsetHeight;
        this.$nextTick(()=>{
            if (document.getElementsByClassName('fixed-table-box')[0]) {
                // document.getElementsByClassName('fixed-table-box')[0].style.width = this.header.offsetWidth + 'px'
            }
        })
        

        window.addEventListener('scroll', this.handleScroll, true);
        window.addEventListener('resize', this.handleScroll, true);

    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll, true);
        window.removeEventListener('resize', this.handleScroll, true);

    },
    methods: {
        handleScroll(e) {
            // 监听dom渲染完成
            this.$nextTick(function () {
                this.header = document.getElementById("fixedHeaderRoot");

                // 这里fixedHeaderRoot是吸顶元素的ID
                // 这里要得到top的距离和元素自身的高度
                this.offsetTop = this.header.offsetTop;
                this.offsetHeight = this.header.offsetHeight;
            });

            let fixedTable = document.getElementById('fixed-table');
            let scrollTop = fixedTable.scrollTop;
            if (scrollTop >= this.offsetTop){
                document.getElementById("fixed-thead-top").className = 'fixed-thead-top'
            }else{
                if(document.getElementsByClassName('fixed-thead-top')[0]){
                    if (scrollTop+50 < this.offsetTop){
                        document.getElementById("fixed-thead-top").classList.remove('fixed-thead-top')
                    }
                }
            }

            // 得到页面滚动的距离
            // let scrollTop = fixedTable.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || fixedTable.scrollY;
            // 判断页面滚动的距离是否大于吸顶元素的位置
            this.headerFixed = scrollTop > (this.offsetTop + 48 - 64);
            if (document.getElementsByClassName('fixed-table-box')[0]){
                // document.getElementsByClassName('fixed-table-box')[0].style.width = this.header.offsetWidth + 'px'
            }
        },
    }

}